import React, { PureComponent } from 'react';
import { TransactionData } from '../../../../domain/stream/transaction/TransactionDomains';
import { CaseSettings } from '../../../../domain/case/CaseDomains';
import CaseListModalComponent from '../list/CaseListModalComponent';

class CaseCloseListComponent extends PureComponent<Props> {
  public render() {
    const { transactionData, disabled = false, domain } = this.props;
    return <CaseListModalComponent transactionData={transactionData} disabled={disabled} domain={domain} />;
  }
}

interface Props {
  transactionData: TransactionData;
  disabled?: boolean;
  domain: CaseSettings;
}

export default CaseCloseListComponent;
